import axios from "axios";
import {User} from "oidc-client-ts";

function getUser() {
  const oidcStorage = sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_KEYCLOAK_URL}realms/${process.env.REACT_APP_KEYCLOAK_REALM}:${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`)
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

const getHeaders = async () => {
  let headers = {};
  const selectedLang = localStorage.getItem("beppoSelectedLanguage");
  if (selectedLang !== null) {
    headers['Accept-Language'] = selectedLang;
  }
  const user = getUser();
  if (user?.access_token) {
    headers['Authorization'] = `Bearer ${user?.access_token}`;
  }

  return headers;
};

// axios.defaults.validateStatus (src/axios.js) resolves every 4xx, so the
// error body would otherwise be handled as data. Rejects like axios would.
export const rejectIfNotOk = (res) => {
  if (res.status >= 300) {
    const e = new Error(`Request failed with status code ${res.status}`);
    e.response = res;
    throw e;
  }
  return res;
};

export const apiService = {
  async get(url, config = {}) {
      const headers = await getHeaders();
      return await axios.get(url, {
          headers,
          ...config,
      });
  },
  async post(url, body) {
      const headers = await getHeaders();
      return await axios.post(url, body, {
          headers,
      });
  },
  async postForm(url, body) {
      const headers = await getHeaders();
      return await axios.postForm(url, body, {
          headers,
      });
  },
  async put(url, body, config = {}) {
      const headers = await getHeaders();
      return await axios.put(url, body, {
          headers,
          ...config,
      });
  },
  async putForm(url, body) {
      const headers = await getHeaders();
      return await axios.putForm(url, body, {
          headers,
      });
  },
  async delete(url) {
      const headers = await getHeaders();
      return await axios.delete(url, {
          headers,
      });
  },
  async patch(url, body) {
      const headers = await getHeaders();
      return await axios.patch(url, body, {
          headers,
      });
  },
  async getDocument(url) {
      const headers = await getHeaders();
      return await axios.get(url, {
          responseType: "blob",
          headers: headers,
      });
  },
  async getDocumentPost(url, body) {
      const headers = await getHeaders();
      return await axios.post(url, body, {
          responseType: "blob",
          headers: headers,
      });
  },
  async postWithCancelToken(url, body, ourRequest) {
      const headers = await getHeaders();
      return await axios.post(url, body, {
          headers: headers,
          cancelToken: ourRequest.token,
      });
  },
};
